import { GtmDimensions, GtmEventNames } from 'google-tag-manager';
import { pushToDataLayer } from './utils/helpers';
import { SessionStorageService } from '../stores';

// TODO: CDT-831 Revoke Flexi workaround pushDimension12UpdateData() when Flexi EPIC is implemented
export const pushDimension12UpdateData = () => {
  const updateData = {
    [GtmDimensions.event]: GtmEventNames.dimension12Update,
    [GtmDimensions.testVariant]: 'MAMBA'
  };
  pushToDataLayer(updateData);

  SessionStorageService.setItem(GtmDimensions.referralPageCategory, 'CORE');
};
